/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';
import { ApiDefUserData } from '../../models/api-def-user-data';

export interface AuthMe$Params {

/**
 * The domain of the project to retrieve user information from
 */
  domain?: string;
}

export function authMe(http: HttpClient, rootUrl: string, params?: AuthMe$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'userData'?: ApiDefUserData;
'projectData'?: ApiDefProjectData;
}>> {
  const rb = new RequestBuilder(rootUrl, authMe.PATH, 'get');
  if (params) {
    rb.query('domain', params.domain, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'userData'?: ApiDefUserData;
      'projectData'?: ApiDefProjectData;
      }>;
    })
  );
}

authMe.PATH = '/auth/me';
